module.exports = __webpack_public_path__ + "img/icon-lock-menu-covid.bee581d3.svg";